// SubFieldList.tsx
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { Publication } from "../../types/source.types";

type Props = {
  items: Publication[];
  selectedIds: Set<number>;
  onToggle: (id: number) => void;
  search?: string;
};

export function SubFieldList({ items, selectedIds, onToggle, search }: Props) {
  const isMatch = (name: string, term: string) => {
    if (!term?.trim()) return false;
    return name.toLowerCase().includes(term.toLowerCase().trim());
  };

  const highlight = (text: string, term: string) => {
    if (!term?.trim()) return text;
    const regex = new RegExp(`(${term.trim()})`, "gi");
    return text.split(regex).map((part, idx) =>
      part.toLowerCase() === term.toLowerCase().trim() ? (
        <mark key={idx} className="text-neutral-800">
          {part}
        </mark>
      ) : (
        part
      ),
    );
  };

  return (
    <div
      className="grid grid-cols-2 gap-3 sm:grid-cols-3"
      style={{ contain: "layout style", willChange: "auto" }}
    >
      {items.map((item) => {
        const checked = selectedIds.has(item.id);
        const matched = isMatch(item.name, search || "");

        return (
          <div
            key={item.id}
            className={`flex min-w-0 items-center space-x-2 rounded-md transition-colors`}
          >
            <Checkbox
              id={`pub-${item.id}`}
              checked={checked}
              onCheckedChange={() => onToggle(item.id)}
              className="flex-shrink-0"
            />
            <Label
              htmlFor={`pub-${item.id}`}
              className={`cursor-pointer truncate text-sm font-semibold ${
                matched ? "text-neutral-800" : "text-neutral-800"
              }`}
              title={item.name}
            >
              {search?.trim() ? highlight(item.name, search) : item.name}
            </Label>
          </div>
        );
      })}
    </div>
  );
}
